// @flow
import React from 'react';
import { get } from 'lodash';
import { Icons, CustomValidation, Button } from 'sarsaparilla';

import type { OnChangeEventType } from '../types';

type PropTypes = {
  alternateLeaderValidatorMethod: Function,
  handleAlternateLeaderValidation: Function,
  className: string,
  handleAlternateLeaderChange: Function,
  isDisabled: boolean,
  index: number,
  leader: {
    email: string,
    first_name: string,
    last_name: string,
    phone: string
  },
  removeLeader: Function
};


export default class AlternatePermitHolderEntry extends React.PureComponent<PropTypes> {
  static defaultProps = {
    isDisabled: false,
    className: ''
  }

  onClickRemove = () => this.props.removeLeader(parseInt(this.props.index, 10));

  handleChange = ({ target: { id, value }}: OnChangeEventType<string>) => this.props.handleAlternateLeaderChange(this.props.index, id, value);

  renderRemoveLeaderButton() {
    if (this.props.isDisabled) {
      return <div />;
    }

    return (
      <div className="alternate-group-leader">
        <Button
          type="button"
          className="remove-leader-link"
          onClick={this.onClickRemove}
          iconBeforeElement={<Icons.IconCloseCircle />}
          screenReaderTextBefore="Close" />
      </div>
    );
  }

  render() {
    const { className, index, isDisabled, leader } = this.props;
    return (
      <div className="permit-alt-input-wrap">
        <div className="permit-alt-header-wrap">
          <div className="permit-alt-header">
            Alternate Permit Holder #{index + 1}
          </div>
          {this.renderRemoveLeaderButton()}
        </div>
        <div className="rec-form-item-wrap">
          <label htmlFor={`alt-email-${index + 1}`}>Email Address</label>
          <input
            id={`alt-email-${index + 1}`}
            type="text"
            className={className}
            value={get(leader, 'email', '')}
            onChange={this.handleChange}
            readOnly={isDisabled}
            disabled={isDisabled} />
          <CustomValidation
            value={get(leader, 'email', '')}
            displayInSummary
            customValidator={this.props.alternateLeaderValidatorMethod}
            onValidated={this.props.handleAlternateLeaderValidation}
            controlLabel="Alternate Permit Holder Email Address" />
        </div>
      </div>
    );
  }
}
